import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  flex?: boolean;
  fontContainer?: boolean;
}

export const Root = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

export const Container = styled.div`
   padding: 23px 39px;
  position: relative;
`;

export const Back = styled.div`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${C.BLUE};
  position: relative;
  padding-left: 23px;
  cursor: pointer;
  text-transform: uppercase;
`;

export const Icon = styled.div`
  position: absolute;
  left: 0px;
  top: -4px;
`;

export const List = styled.div`
  .group-list {
    padding: 8px;
    display: ${(props: IRootProps) => props.flex ? 'grid' : 'unset'};
    grid-template-columns: ${(props: IRootProps) => props.flex ? props.fontContainer ? 'repeat(auto-fill, 240px)' : 'repeat(auto-fill, 190px)' : 'unset'};
    justify-content: ${(props: IRootProps) => props.flex ? 'space-between' : 'unset'};
  }
`;

export const Title = styled.div`
  font-family: Roboto;
  font-size: 25px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
  margin-top: 46px;
  margin-left: 24px;
  margin-bottom: 23px;
  text-transform: capitalize;
`;

export const LoaderContainer = styled.div`
`

export const EndMessage = styled.div`
  width:100%;
  text-align:center;
  font-size: 15px;
  font-weight: normal;
  color: #122442;
  display: inline-block;
`;